const domain = new RegExp('^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}[a-zA-Z0-9](\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+[0-9a-zA-Z]$');
export default domain;






// WEBPACK FOOTER //
// ./src/common/reg/domain.js